import { render, staticRenderFns } from "./editusertype.vue?vue&type=template&id=19c7f239"
import script from "./editusertype.vue?vue&type=script&lang=js"
export * from "./editusertype.vue?vue&type=script&lang=js"
import style0 from "./editusertype.vue?vue&type=style&index=0&id=19c7f239&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports